<template>
  <div>
    <DialogComponent
      ref="dialog"
      type="fullscreen"
      noInnerPadding
      hideCloseButton
    >
      <DishDetail
        v-if="dishData"
        :dishData="dishData"
        @close="() => $refs.dialog.hide()"
      />
      <!-- Shimmer loading state -->
      <div v-else class="h-full flex flex-col bg-white">
        <div class="mobile-margin-top py-4 px-6">
          <div class="w-9 h-9 rounded-full shimmerElementRoundedDefault"></div>
        </div>
        <div
          class="w-full py-[35%] relative shimmerElementRoundedDefault"
        ></div>
        <div class="bg-white rounded-t-3xl py-8 -mb-8 -mt-8 relative"></div>
        <div class="relative bg-white px-6">
          <div class="h-8 w-3/4 shimmerElement rounded-xl mb-4"></div>
          <div class="h-6 w-1/2 shimmerElement rounded-xl mb-2"></div>
          <div class="h-6 w-1/3 shimmerElement rounded-xl"></div>
        </div>
      </div>
    </DialogComponent>
  </div>
  <VBusHelper
    :reactOn="$constants.EVENTS.ORDERS.CREATED"
    :handler="closeDialog"
  />
</template>
<script setup>
import {
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
  getCurrentInstance
} from 'vue';
import DishDetail from './DishDetail.vue';

const dialog = ref(null);
const dishData = ref(null);
const isOpen = ref(false);
const isLoading = ref(false);
const { proxy } = getCurrentInstance();
const { $constants, $bus } = proxy;

const closeDialog = () => {
  dialog.value.hide();
};
const showDetails = async (payload) => {
  if (!payload?.id) return;
  dialog.value.show();

  // Reset state
  dishData.value = null;

  // Listen for the loaded event
  const onLoaded = (dish) => {
    dishData.value = dish;
    setTimeout(() => {
      isOpen.value = true;
    }, 300);
    $bus.off($constants.EVENTS.DISH.DISH_DETAIL_LOADED, onLoaded);
  };

  const onError = (error) => {
    console.error('Failed to load dish:', error);
    dialog.value.hide();
    $bus.off($constants.EVENTS.DISH.DISH_DETAIL_ERROR, onError);
  };

  $bus.on($constants.EVENTS.DISH.DISH_DETAIL_LOADED, onLoaded);
  $bus.on($constants.EVENTS.DISH.DISH_DETAIL_ERROR, onError);

  // Trigger the API call
  $bus.emit($constants.EVENTS.DISH.DISH_DETAILS_REQUESTED, { id: payload.id });
};

onMounted(() => {
  $bus.on($constants.EVENTS.DISH.SHOW_DISH_DETAIL, showDetails);
});

onBeforeUnmount(() => {
  $bus.off($constants.EVENTS.DISH.SHOW_DISH_DETAIL, showDetails);
});
</script>
